import { createTheme, responsiveFontSizes } from '@mui/material/styles';
import vas from './vas.js';
import foresight from './foresight.js';
import command from './command.js';
import { spacing, colors } from 'styles/Common';

const defaultTheme = createTheme();

const base = {
    typography: {
        fontFamily: '"3MCircularTT"'
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                body: {
                    fontSize: '14px',
                    fontWeight: 300,
                    fontStretch: 'normal',
                    fontStyle: 'normal',
                    letterSpacing: '0.07px',
                    color: colors.fillGray70
                }
            }
        },
        MuiInputBase: {
            styleOverrides: {
                root: {
                    height: 36,
                    fontSize: 14,
                }
            }
        },
        MuiInputAdornment: {
            styleOverrides: {
                root: {
                    fontSize: 12
                }
            }
        },
        MuiOutlinedInput: {
            styleOverrides: {
                input: {
                    paddingTop: 10,
                    paddingBottom: 10
                },
                adornedStart: {
                    paddingLeft: defaultTheme.spacing(1)
                },
                adornedEnd: {
                    paddingRight: defaultTheme.spacing(1)
                }
            }
            
        },
        MuiChip: {
            styleOverrides: {
                root: {
                    backgroundColor: '#99e1ad',
                },
                label: {
                    color: '#00711f'
                },
                deleteIcon: {
                    color: '#00711f'
                }
            }
        },
        MUIDataTableHeadCell: {
            styleOverrides: {
                root: {
                    whiteSpace: 'nowrap'
                }
            }
        },
        MUIDataTableHeadRow: {
            styleOverrides: {
                root: {
                    backgroundColor: defaultTheme.palette.grey[100]
                }
            }
        },
        MuiTab: {
            styleOverrides: {
                root: {
                    textTransform: 'none'
                }
            }   
        },
        MuiButton: {
            variant: 'contained'
        }
    },
    palette: {
        primary: {
            main: '#003CE5',
            light: '#bfdaf9'
        },
        secondary: {
            main: '#03C7E5',
            light: '#A2E8F3'
        },
        error: {
            main: '#F44336',
            light: '#E57373'
        },
        info: {
            main: '#F9C913',
            light: '#ffe066'
        },
        success: {
            main: '#006633',
            light: '#00C61A'
        },
        text: {
            primary: '#4D4D4D',
            secondary: '#919191'
        },
        /*begin FS custom*/
        location: {
            main: '#003CE5'
        },
        selectedLocation: {
            main: '#f9c913'
        },
        /*end FS custom*/
        tonalOffset: 0.2,
    },
    spacing: (index) => { return spacing[index] }
};

const getAppTheme = (appTheme) => {
    return {
        ...base,
        palette: {
            ...base.palette,
            ...(appTheme ? appTheme.palette : null),
            type: 'light'
        },
        components: {
            ...base.components,
            MuiTableHead: {
                styleOverrides: {
                    root: {
                        whiteSpace: 'nowrap',
                        backgroundColor: 'transparent'
                    },
                    fixedHeader: {
                        backgroundColor: 'transparent'
                    }
                }
            },
            MUIDataTableHeadRow: {
                styleOverrides: {
                    root: {
                        backgroundColor: defaultTheme.palette.grey[100]
                    }
                }
            },
        },
        typography: {
            ...(appTheme ? appTheme.typography : null)
        }
    };
};

const getTheme = (appThemeName) => {
    var appTheme;

    switch (appThemeName) {
        case 'vas':
            appTheme = vas;
            break;
        case 'foresight':
            appTheme = foresight;
            break;
        case 'command':
            appTheme = command;
            break;
        default:
            appTheme = vas;
    }

    return responsiveFontSizes(createTheme(getAppTheme(appTheme)));
};

export default getTheme;
